import { Center, Divider, Flex } from "@chakra-ui/react"
import { ProjectsComponent } from "../../components/projects"
import { RepositoryComponent } from "../../components/repositories"
import { repos } from "../../components/repositories/mock/repositories"
import { DefaultTemplate } from "../../components/templates"

export const ProjectsPage = () => {
  const renderRepos = () => {
    return repos.map((repo) => <RepositoryComponent {...repo} />)
  }

  return (
    <DefaultTemplate>
      <Flex minH={"90vh"} direction="column">
        <ProjectsComponent />

        <Center>
          <Divider bg={"grey.200"} border={2} maxW={"98vw"} />
        </Center>

        <Flex justifyContent={"space-around"}>{renderRepos()}</Flex>
      </Flex>
    </DefaultTemplate>
  )
}
